import React from "react";
import { Spinner } from "react-bootstrap";
import styled from "styled-components";

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(3px);
  animation: fadeIn 0.2s ease-in;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const LoadingCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 2.5rem 3rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  min-width: 320px;
  max-width: 420px;
  animation: slideUp 0.3s ease-out;
  
  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const LoadingText = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #45464e;
  text-align: center;
  font-family: "DM Sans", sans-serif;
`;

const LoadingSubtext = styled.p`
  margin: 0;
  font-size: 14px;
  color: #525252;
  text-align: center;
  font-family: "Work Sans", sans-serif;
  line-height: 1.5;
`;

export default function FormLoadingOverlay({ message = "Creating member...", subMessage = "Please wait while we process your request" }) {
  return (
    <OverlayContainer>
      <LoadingCard>
        <Spinner
          animation="border"
          role="status"
          style={{
            width: "3rem",
            height: "3rem",
            borderWidth: "4px",
            borderColor: "var(--color-primary)",
            borderRightColor: "transparent",
          }}
        />
        <div>
          <LoadingText>{message}</LoadingText>
          <LoadingSubtext>{subMessage}</LoadingSubtext>
        </div>
      </LoadingCard>
    </OverlayContainer>
  );
}

